import { decryptWithAES, encryptWithAES } from "utils/parse";
import http from "../../index";
import { Admin, LoginData, LoginResponse } from "./types";
import Cookies from "js-cookie";

namespace auth {
  const userKey = "app.user";
  const tokenKey = "app.token";
  const orgKey = "org.id";

  export const saveToken = (token: string) => {
    Cookies.set(tokenKey, token, {
      domain: import.meta.env.VITE_SSO_DOMAIN,
    });
  };

  export const rememberUser = (values: LoginData) => {
    if (values.remember) {
      localStorage.setItem(userKey, encryptWithAES(JSON.stringify(values)));
    } else {
      localStorage.removeItem(userKey);
    }
  };

  export const getRememberUser = () => {
    const userData = localStorage.getItem(userKey);
    if (userData) {
      const _userData = JSON.parse(decryptWithAES(userData)) as LoginData;
      return _userData;
    }
    return undefined;
  };

  export const remToken = () => {
    Cookies.remove(tokenKey);
  };

  export const hasToken = () => !!Cookies.get(tokenKey);

  export const getToken = () => Cookies.get(tokenKey);

  export const setOrg = (id: string | undefined) => {
    if (id) localStorage.setItem(orgKey, id);
  };

  export const getOrg = () => localStorage.getItem(orgKey);

  export const info = () =>
    http.get<Admin>("shared/auth/info", { hasAuth: true });

  export const login = (body: LoginData) =>
    http.post<LoginResponse>("shared/auth/login", {
      body,
    });
}

export default auth;
